import React from "react";
import { useI18n } from "../../lib/i18n";
import {
  Vault,
  Handshake,
  ChartLineUp,
  Gavel,
  Storefront,
  PaintBrush,
  Buildings,
  ShieldCheck,
  PencilRuler,
  ArrowUpRight,
} from "@phosphor-icons/react";

const SERVICE_IMG = {
  wealth:
    "https://static.prod-images.emergentagent.com/jobs/90dd8daa-cd26-4f72-b7b0-ddd9192df92a/images/44e7a2406a8be57c768e8acc4a3bca88c3c33e3218ac2ee7caff8284e532b517.png",
  auctions:
    "https://static.prod-images.emergentagent.com/jobs/90dd8daa-cd26-4f72-b7b0-ddd9192df92a/images/df0333cae41863ed97b55114c9821bfd0c26249cc16ed9d8e3eb97ff2a4af93c.png",
  enhancement:
    "https://images.unsplash.com/photo-1776482128065-ae388030a0b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  sale:
    "https://images.unsplash.com/photo-1677594332740-479907711bb4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  interior:
    "https://images.unsplash.com/photo-1776482128065-ae388030a0b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export default function Services() {
  const { t } = useI18n();

  // Bento layout for 9 services in a 12-column grid.
  // Pattern: 7+5, 5+7, 7+5, 5+7, 12 (last row full-width interior)
  const services = [
    {
      key: "wealth",
      icon: Vault,
      ...t.services.items.wealth,
      span: "lg:col-span-7",
      hasImage: true,
      img: SERVICE_IMG.wealth,
    },
    {
      key: "sale",
      icon: Handshake,
      ...t.services.items.sale,
      span: "lg:col-span-5",
    },
    {
      key: "invest",
      icon: ChartLineUp,
      ...t.services.items.invest,
      span: "lg:col-span-5",
    },
    {
      key: "auctions",
      icon: Gavel,
      ...t.services.items.auctions,
      span: "lg:col-span-7",
      hasImage: true,
      img: SERVICE_IMG.auctions,
    },
    {
      key: "consulting",
      icon: Storefront,
      ...t.services.items.consulting,
      span: "lg:col-span-7",
    },
    {
      key: "enhancement",
      icon: PaintBrush,
      ...t.services.items.enhancement,
      span: "lg:col-span-5",
      hasImage: true,
      img: SERVICE_IMG.enhancement,
    },
    {
      key: "valorization",
      icon: Buildings,
      ...t.services.items.valorization,
      span: "lg:col-span-5",
    },
    {
      key: "insurance",
      icon: ShieldCheck,
      ...t.services.items.insurance,
      span: "lg:col-span-7",
    },
    {
      key: "interior",
      icon: PencilRuler,
      ...t.services.items.interior,
      span: "lg:col-span-12",
      hasImage: true,
      img: SERVICE_IMG.interior,
    },
  ];

  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-white py-24 lg:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="max-w-3xl mb-16">
          <p className="overline mb-5">{t.services.overline}</p>
          <h2 className="font-serif text-4xl lg:text-5xl xl:text-6xl text-[#0A1428] leading-[1.1] tracking-tight font-medium">
            {t.services.title}
          </h2>
          <p className="mt-6 text-[#4A5568] text-lg max-w-2xl leading-relaxed">
            {t.services.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 auto-rows-fr">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.key}
                data-testid={`service-card-${s.key}`}
                className={`group relative card-elegant p-8 lg:p-10 flex flex-col justify-between min-h-[300px] ${s.span}`}
              >
                {s.hasImage && (
                  <div className="absolute inset-0 z-0 opacity-15 group-hover:opacity-25 transition-opacity">
                    <img src={s.img} alt="" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-br from-white via-white/80 to-white/40" />
                  </div>
                )}
                <div className="relative z-10">
                  <div className="w-12 h-12 bg-[#C5A059]/10 flex items-center justify-center mb-6">
                    <Icon size={26} weight="duotone" className="text-[#C5A059]" />
                  </div>
                  <h3 className="font-serif text-2xl lg:text-3xl text-[#0A1428] font-medium leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-[#4A5568] leading-relaxed">{s.desc}</p>
                </div>
                <div className="relative z-10 mt-8 flex items-center gap-2 text-[#0A1428] group-hover:text-[#C5A059] transition-colors">
                  <ArrowUpRight size={20} weight="bold" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
